(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const header = document.getElementById('MainHeader');
    const headerPlaceholder = document.getElementById('HeaderPlaceholder');
    
    // Scroll state logic
    const handleScroll = () => {
      if (window.scrollY > 120) {
        if (!header.classList.contains('header--scrolled')) {
          headerPlaceholder.style.height = `${header.offsetHeight}px`;
          header.classList.add('header--scrolled');
        }
      } else {
        if (header.classList.contains('header--scrolled')) {
          header.classList.remove('header--scrolled');
          headerPlaceholder.style.height = '';
        }
      }
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Init on load

    // Mobile menu logic
    const menuToggle = document.getElementById('MobileMenuToggle');
    const menuClose = document.getElementById('MobileMenuClose');
    const menuOverlay = document.getElementById('MobileMenuOverlay');
    const body = document.body;

    const openMenu = () => {
      menuOverlay.classList.add('is-open');
      menuToggle.setAttribute('aria-expanded', 'true');
      body.style.overflow = 'hidden'; // Prevent scroll behind
    };

    const closeMenu = () => {
      menuOverlay.classList.remove('is-open');
      menuToggle.setAttribute('aria-expanded', 'false');
      body.style.overflow = '';
    };

    if (menuToggle && menuClose && menuOverlay) {
      menuToggle.addEventListener('click', openMenu);
      menuClose.addEventListener('click', closeMenu);
      
      // Close menu when clicking a link
      const menuLinks = menuOverlay.querySelectorAll('a');
      menuLinks.forEach(link => {
        link.addEventListener('click', closeMenu);
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
